module.exports = __webpack_public_path__ + "static/media/Spanish_US_Antonio BG-17.ebf716dd.png";